import React from 'react';
import { SOCIAL_PLATFORMS } from 'ui-components';
import { PARTIALLY_SUPPORTED_PLATFORMS } from '~/constants';
import { Platform } from '~/screens/types';

import { useAdvancedFiltersStore } from '../../store/useAdvancedFilterStore';
import {
  followers,
  snapchatFollowers,
  subscribers,
  tiktokFollowers,
} from './FollowerMetricsConstants';
import { MetricsSlider } from './MetricsSlider';
import { FILTERS } from './SearchByFollowers';

const InstagramFollowers: React.FC = () => {
  const { getFilter } = useAdvancedFiltersStore();

  return (
    <MetricsSlider
      title="Followers"
      value={getFilter(SOCIAL_PLATFORMS.instagram, FILTERS.igFollowers) || 0}
      metrics={followers}
      filterType={FILTERS.igFollowers}
    />
  );
};

const TiktokFollowers: React.FC = () => {
  const { getFilter } = useAdvancedFiltersStore();
  return (
    <MetricsSlider
      title="Followers"
      value={getFilter(SOCIAL_PLATFORMS.tiktok, FILTERS.ttFollowers) || 0}
      metrics={tiktokFollowers}
      filterType={FILTERS.ttFollowers}
    />
  );
};
const YoutubeFollowers: React.FC = () => {
  const { getFilter } = useAdvancedFiltersStore();
  return (
    <MetricsSlider
      title="Subscribers"
      value={getFilter(SOCIAL_PLATFORMS.youtube, FILTERS.ytFollowers) || 0}
      metrics={subscribers}
      filterType={FILTERS.ytFollowers}
    />
  );
};
const SnapchatFollowers: React.FC = () => {
  const { getFilter } = useAdvancedFiltersStore();

  return (
    <MetricsSlider
      title="Followers"
      value={
        getFilter(
          PARTIALLY_SUPPORTED_PLATFORMS.snapchat,
          FILTERS.scFollowers,
        ) || 0
      }
      metrics={snapchatFollowers}
      filterType={FILTERS.scFollowers}
    />
  );
};

interface FollowerMetricsProps {
  activePlatform: Platform;
}

export function FollowersMetrics({ activePlatform }: FollowerMetricsProps) {
  const FOLLOWER_METRIC_COMPONENT = {
    [SOCIAL_PLATFORMS.instagram]: InstagramFollowers,
    [SOCIAL_PLATFORMS.tiktok]: TiktokFollowers,
    [SOCIAL_PLATFORMS.youtube]: YoutubeFollowers,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: SnapchatFollowers,
  } as const;

  const Followers =
    FOLLOWER_METRIC_COMPONENT[activePlatform] ?? InstagramFollowers;

  return <Followers />;
}
